$(function () {
    //toggle nav
    $(".nzp-nav__opener").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("nzp-nav_open");
        $(".nzp-header__nav").toggleClass("nzp-nav_open");
    });

    //toggle item expansion
    $(".nzp-header__nav").on(
        "click",
        ".nzp-nav__menu-opener, .nzp-nav__menu-item_redirect",
        function (e) {
            e.preventDefault();
            $(this)
                .closest(".nzp-nav__menu-item")
                .toggleClass("nzp-nav__menu-item_open");
        }
    );
});
